<ng-template #WidgetLegend>
  <ng-content *ngTemplateOutlet="chartLegend"></ng-content>
</ng-template>
<mat-toolbar>
  <span>{{ chartConfig.chartTitle }}</span>
  <span class="example-spacer"></span>
  <button *ngIf="showCompareIcon"
  mat-icon-button
  [disabled]="!isCompareEnabled"
  (click)="onCompareButtonClick()"
  [matTooltip] ="!isCompareEnabled ? 'Comparison view is enabled when up to three (3) options are selected from any single search field.' : ''"
>
<i class="fa-solid fa-code-compare"></i>
</button>

  <span>

    <ng-container *ngIf="chartLegend; else noLegend">
      <svg-icon
      src="assets/svg/info_icon.svg"
      [tooltip]="WidgetLegend"
      placement="bottom"
      theme="light"
      contentType="template"
      content-type="template"
    ></svg-icon>
    </ng-container>
    <ng-template #noLegend>
      <svg-icon
      src="assets/svg/info_icon.svg"
      placement="bottom"
      theme="light"
      contentType="template"
      content-type="template"
    ></svg-icon>
    </ng-template>
  </span>
  
  <button mat-icon-button (click)="onPopOutButtonClick()" style="width: 24px">
    <svg-icon src="assets/svg/arrows-expand.svg" width="'30px'"></svg-icon>
  </button>
</mat-toolbar>
<div class="chart-content">
  <ng-container *ngIf="showSpinner$ | async; else chart">
    <mat-spinner></mat-spinner>
  </ng-container>
</div>

<ng-template #chart>
  <tap-chart
    [chartConfig]="chartConfigSm"
    [chartData]="chartData"
    (axisLabelRender)="onAxisLabelRender($event)"
    (chartLoaded)="onChartLoaded($event)"
    (pointRender)="onPointRender($event)"
    (tooltipRender)="onTooltipRender($event)"
    [chartId]="chartId"
    [selectedDataIndexes]="selectedDataIndexes"
  ></tap-chart>
</ng-template>
